<template>
  <modal
      name="month-repeat-modal"
      :width="`100%`"
      :height="576"
      :min-width="700"
      :min-height="450"
      :pivotX="0.5"
      :pivotY="0.5"
      :delay="100"
      :clickToClose="false"
  >
    <vue-scroll>
      <div class="FloatMenu md_overlay md_overlay_0">
        <div class="modal modal_0">
          <div class="md_content" style="max-height: 576px !important; min-width: 700px !important;">
            <h6 class="--blue70 pb20">
              {{$t('RMC.one_month_repeat')}}
            </h6>
            <span class="md_close">
                <img
                    src="/images/union.svg"
                    alt=""
                    @click="modalClose"
                >
            </span>
            <div
                style="min-height: 420px; overflow-x: hidden; overflow-y: auto; margin-bottom: 10px"
            >
              <div
                  v-for="(i, index) in repeat"
                  :key="index"
                  style="height: 200px; padding: 5px; border: 1px solid var(--grey20); border-radius: 5px;margin-right: 5px; margin-bottom: 10px;"
              >
                <div
                    class="table-container input_max"
                    style="width: 600px;display: grid;grid-template-columns: 1fr;grid-template-rows: 60px 60px;"
                >
                  <div class="item-parent">
                    <div class="item-title">
                      {{ $t("monthRepeat.week") }}
                    </div>
                    <div class="item-value">
                      <div>
                        <div
                            class="week"
                            :class="i.week.mon === true ? ' check': ''"
                            @click="handleWeekClick('mon', index)"
                        >
                          {{ weekLabel[0].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.tue === true ? ' check': ''"
                            @click="handleWeekClick('tue', index)"
                        >
                          {{ weekLabel[1].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.wed === true ? ' check': ''"
                            @click="handleWeekClick('wed', index)"
                        >
                          {{ weekLabel[2].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.thu === true ? ' check': ''"
                            @click="handleWeekClick('thu', index)"
                        >
                          {{ weekLabel[3].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.fri === true ? ' check': ''"
                            @click="handleWeekClick('fri', index)"
                        >
                          {{ weekLabel[4].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.sat === true ? ' check': ''"
                            @click="handleWeekClick('sat', index)"
                        >
                          {{ weekLabel[5].label }}
                        </div>
                        <div
                            class="week"
                            :class="i.week.sun === true ? ' check': ''"
                            @click="handleWeekClick('sun', index)"
                        >
                          {{ weekLabel[6].label }}
                        </div>
                      </div>
                      <div>
                        <div
                            style="width: 30px; height: 40px; float: left;"
                            @click="repeat.length - 1 === index && handleAddClick(repeat.length - 1 === index, repeat.length, index)"
                        >
                          <svg
                              v-if="repeat.length - 1 === index"
                              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                              style="display: block; margin: 8px auto; cursor: pointer;"
                          >
                            <path d="M20 11H13V4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4V11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H11V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11Z" fill="#2A589F"/>
                          </svg>
                          <svg
                              v-else
                              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                              style="display: block; margin: 8px auto;"
                          >
                            <path d="M20 11H13V4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4V11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13H11V20C11 20.55 11.45 21 12 21C12.55 21 13 20.55 13 20V13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11Z" fill="#EDEBE9"/>
                          </svg>
                        </div>
                        <div
                            style="width: 30px; height: 40px; float: left;"
                            @click="index !== 0 && handleRemoveClick(index)"
                        >
                          <svg
                              v-if="index !== 0"
                              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                              style="display: block; margin: 8px auto; cursor: pointer;"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM7.03 12C7.03 11.45 7.48 11 8.03 11H15.97C16.52 11 16.97 11.45 16.97 12C16.97 12.55 16.52 13 15.97 13H8.03C7.48 13 7.03 12.55 7.03 12Z" fill="#D83B01"/>
                          </svg>
                          <svg
                              v-else
                              width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                              style="display: block; margin: 8px auto;"
                          >
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12ZM7.03 12C7.03 11.45 7.48 11 8.03 11H15.97C16.52 11 16.97 11.45 16.97 12C16.97 12.55 16.52 13 15.97 13H8.03C7.48 13 7.03 12.55 7.03 12Z" fill="#EDEBE9"/>
                          </svg>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="item-parent">
                    <div class="item-title">
                      {{$t('monthRepeat.medical')}}
                    </div>
                    <div class="item-value">
                      <span
                          v-show="lang() !== 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.from')}}
                      </span>
                      <v-select
                          class="patient_info_value grid-item c_selector"
                          v-model="i.includeFrom"
                          :options="setTimeRange(i.includeTo.no)"
                          :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
                          style="word-break: break-word;width: calc(50% - 50px);float:left;"
                      >
                        <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
                      </v-select>
                      <span
                          v-show="lang() !== 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.to')}}
                      </span>
                      <span
                          v-show="lang() === 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.from')}}
                      </span>
                      <v-select
                          class="item-value"
                          v-model="i.includeTo"
                          :options="setTimeRange(i.includeFrom.no, false)"
                          :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
                          style="word-break: break-word;width: calc(50% - 50px);float:left;"
                      >
                        <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
                      </v-select>
                      <span
                          v-show="lang() === 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.to')}}
                      </span>
                    </div>
                  </div>
                  <div class="item-parent">
                    <div class="item-title"
                    >
                      {{$t('monthRepeat.exclusion')}}
                    </div>
                    <div class="item-value">
                      <span
                          v-show="lang() !== 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.from')}}
                      </span>
                      <v-select
                          class="item-value"
                          v-model="i.excludeFrom"
                          :options="setTimeRange(i.excludeTo.no)"
                          :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
                          style="word-break: break-word;width: calc(50% - 50px);float:left;"
                      >
                        <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
                      </v-select>
                      <span
                          v-show="lang() !== 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.to')}}
                      </span>
                      <span
                          v-show="lang() === 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.from')}}
                      </span>
                      <v-select
                          class="item-value"
                          v-model="i.excludeTo"
                          :options="setTimeRange(i.excludeFrom.no, false)"
                          :get-option-label="option => option.trans ? this.$t(option.trans) : option.title"
                          style="word-break: break-word;width: calc(50% - 50px);float:left;"
                      >
                        <span slot="no-options">{{ $t('patients.no_search_data') }}</span>
                      </v-select>
                      <span
                          v-show="lang() === 'ko'"
                          style="width: 40px;height:40px;text-align: center;padding-top: 10px;float: left;"
                      >
                        {{$t('monthRepeat.to')}}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <a
                  class="btn blue btn_basics pointer no-drag"
                  style="width: calc(50% - 10px);float: left;margin-right: 20px;"
                  @click="handleSave"
              >
                {{ $t('status.save') }}
              </a>
              <a
                  class="btn gray btn_basics pointer no-drag"
                  style="width: calc(50% - 10px);float: left;"
                  @click="modalClose"
              >
                {{ $t('status.cancel') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </vue-scroll>
    <Progress
        :progress="progress"
        :progressLength="progressLength"
        :progressCnt="progressCnt"
        :text="text"
    />
  </modal>
</template>

<script>
import Types from '@/components/Table/types'
import {
  _START_TIME_RANGE,
  _DATETIME_FORMAT,
} from "@/components/Table/static";
import _API from '../../../../api';
import Progress from '../progress'

const defaultRepeatValues = [
  {
    includeFrom: {no: 9,title: '09:00 AM', value: '09:00'},
    includeTo: {no: 45,title: '06:00 PM', value: '18:00'},
    excludeFrom: {no: 25,title: '01:00 PM', value: '13:00'},
    excludeTo: {no: 29,title: '02:00 PM', value: '14:00'},
    week: {
      mon: true,
      tue: true,
      wed: true,
      thu: true,
      fri: true,
      sat: false,
      sun: false,
    },
  },
  {
    includeFrom: {no: 13,title: '10:00 AM', value: '10:00'},
    includeTo: {no: 25,title: '01:00 PM', value: '13:00'},
    excludeFrom: {
      no: 0,
      title: '-',
      value: undefined
    },
    excludeTo: {
      no: 0,
      title: '-',
      value: undefined
    },
    week: {
      mon: false,
      tue: false,
      wed: false,
      thu: false,
      fri: false,
      sat: true,
      sun: false,
    },
  }
]
const defaultRepeat = {
  includeFrom: {
    no: 0,
    title: '-',
    value: undefined
  },
  includeTo: {
    no: 0,
    title: '-',
    value: undefined
  },
  excludeFrom: {
    no: 0,
    title: '-',
    value: undefined
  },
  excludeTo: {
    no: 0,
    title: '-',
    value: undefined
  },
  week: {
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false,
    sun: false,
  },
};

export default {
  components: {
    SelectBox: Types.SelectBox,
    Progress,
  },
  props: [
    'weekDays',
  ],
  data() {
    return {
      lang: () => {
        const language = navigator?.language || navigator?.userLanguage;
        const currentLang = localStorage.getItem('lang') ?? language;
        const korean = currentLang.includes('ko');
        const chinese = currentLang.includes('zh');
        const czech = currentLang.includes('cs');

        if (korean)
          return 'ko';
        // TODO: 중국어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese)
          return 'zh-hk';
        // TODO: 체코어 운영 배포시 URL 체크 삭제
        else if (!window.location.href.includes('https://manager.rebless.clinic') && czech)
          return 'cs';
        else
          return 'en';
      },
      repeat: JSON.parse(JSON.stringify([defaultRepeat])),
      timeRange: [
        {
          no: 0,
          title: '-',
          value: undefined
        },
        ..._START_TIME_RANGE,
        {
          no: 57,
          title: '09:00 PM',
          value: '21:00',
        }
      ],
      weekLabel: [
        {"label": "Monday", "hide": 0},
        {"label": "Tuesday", "hide": 0},
        {"label": "Wednesday", "hide": 0},
        {"label": "Thursday", "hide": 0},
        {"label": "Friday", "hide": 0},
        {"label": "Saturday", "hide": 0},
        {"label": "Sunday", "hide": 0}
      ],
      progress: false,
      progressLength: undefined,
      progressCnt: undefined,
      text: undefined,
    }
  },
  beforeCreate() {
    console.dev('beforeCreate');
  },
  created() {
    console.dev('created');
  },
  beforeMount() {
    console.dev('beforeMount');
  },
  mounted() {
    console.dev('mounted');
    this.$nextTick(function () {
      console.dev('mounted', '$nextTick');
    })
  },
  beforeUpdate() {
    console.dev('beforeUpdate');
  },
  updated() {
    console.dev('updated');
    this.$nextTick(function () {
      console.dev('updated', '$nextTick');
    })
  },
  activated() {
    console.dev('activated');
  },
  deactivated() {
    console.dev('deactivated');
  },
  beforeDestroy() {
    console.dev('beforeDestroy');
  },
  destroyed() {
    console.dev('destroyed');
  },
  errorCaptured(err, vm, info) {
    console.dev('errorCaptured', err, vm, info);
  },
  methods: {
    close(e) {
      if (e.keyCode === 27) {
        e.stopPropagation();
        this.modalClose();
      }
    },
    modalClose: function () {
      document.removeEventListener('keyup', this.close)

      this.repeat = JSON.parse(JSON.stringify([defaultRepeat]));
      this.$modal.hide('month-repeat-modal');
    },
    handleWeekClick(value, index) {
      this.repeat[index].week[value] = !this.repeat[index].week[value];
    },
    handleAddClick() {
      this.repeat.push(JSON.parse(JSON.stringify(defaultRepeat)));
    },
    handleRemoveClick(index) {
      this.repeat.splice(index, 1);
    },
    setLoopData(checkFromDate, checkToDate) {
      let temp = [];

      if (checkFromDate !== undefined && checkToDate !== undefined) {
        let toDayDate = this.moment().format('YYYY-MM-DD');
        let loopFromDate = this.moment(`${toDayDate} ${checkFromDate}:00`);
        let loopToDate = this.moment(`${toDayDate} ${checkToDate}:00`);

        while (loopFromDate.diff(loopToDate, "minutes") < 0) {
          if (Number(loopFromDate.format('HH')) >= 7 && Number(loopFromDate.format('HH')) < 21)
            temp.push(loopFromDate.format('HH:mm:ss'));
          loopFromDate = loopFromDate.add(15, 'minutes');
        }
      }

      return temp;
    },
    setAddDay(weekKey) {
      let today = this.moment().day();
      let weekValue = [
        'sun',
        'mon',
        'tue',
        'wed',
        'thu',
        'fri',
        'sat',
      ];

      let addDay = weekValue.findIndex((value) => weekKey === value) - today;

      return addDay < 0 ? addDay + 7 : addDay;
    },
    setData() {
      let overlap = false;
      let fullList = [];
      let includeList = [];
      let excludeList = [];

      this.repeat.map((item) => {
        if ((item.includeFrom.value !== undefined && item.includeTo.value !== undefined) || (item.excludeFrom.value !== undefined && item.excludeTo.value !== undefined)) {
          let include = this.setLoopData(item.includeFrom.value, item.includeTo.value);
          let exclude = this.setLoopData(item.excludeFrom.value, item.excludeTo.value);

          if (overlap === false)
            overlap = include.filter(x => exclude.includes(x)).length !== 0;

          include = include.filter(x => !exclude.includes(x));

          for (const weekKey in item.week) {
            if (item.week[weekKey]) {
              const addDay = this.setAddDay(weekKey);
              const day = this.moment().add('day', addDay).format('YYYY-MM-DD');

              include.map((cItem) => {
                const data = this.moment(`${day} ${cItem}`).format(_DATETIME_FORMAT);
                if (!includeList.includes(data))
                  includeList.push(data)

                if (!fullList.includes(data))
                  fullList.push(data)
                else
                  overlap = true;
              })

              exclude.map((cItem) => {
                const data = this.moment(`${day} ${cItem}`).format(_DATETIME_FORMAT);
                if (!excludeList.includes(data))
                  excludeList.push(data)

                if (!fullList.includes(data))
                  fullList.push(data)
                else
                  overlap = true;
              })
            }
          }
        }
      })

      return {
        includeList,
        excludeList,
        overlap: false
      }
    },
    handleSave(event, check = true, rtnListData = undefined) {
      const listData = rtnListData === undefined ? this.setData() : rtnListData;

      const registration = () => {
        let reset = [];
        // let APIList = [];
        const param = {
          startDatetime: this.moment.tz(this.moment().format(`YYYY-MM-DDT00:00:00Z`), this._TIME_ZONE).format(),
          endDatetime: this.moment.tz(this.moment().add(1, 'month').format(`YYYY-MM-DDT00:00:00Z`), this._TIME_ZONE).add({h: 24}).format(),
        };

        this.progress = true;
        _API.SCHEDULE.getAllScheduleByRangeForClinic(param)
            .then(async ({data}) => {
              if (data.isSuccess) {
                // const date = this.moment().add(1, 'month').format(`YYYY-MM-DDT00:00:00Z`);
                data.scheduleList.map((eventItem) => {
                  if (!eventItem.isAppointed && eventItem.seqMedicalRelation === 0) {
                    reset.push({
                      seqSchedule: eventItem.seqSchedule,
                      reservableTimelineGroup: eventItem.reservableTimelineGroup,
                    })

                    // if (reset.length >= 100) {
                    //   APIList.push({
                    //     includeTimelineList: [],
                    //     excludeTimelineList: reset,
                    //     repeatEndDatetime: date
                    //   });
                    //   reset = [];
                    // }
                  }
                })

                // if (reset.length !== 0)
                //   APIList.push({
                //     includeTimelineList: [],
                //     excludeTimelineList: reset,
                //     repeatEndDatetime: date
                //   });

                // this.progressLength = APIList.length;
                // this.progressCnt = 0;
                // let tempSpeed = 0;

                // for (let i = 0; i < APIList.length; i++) {
                //   // let startTime = new Date();
                //   await _API.SCHEDULE.updateTimeline(APIList?.[i])
                //   // this.progressCnt = i + 1;
                //   // let diff = ((new Date()).getTime() - startTime.getTime()) / 1000;
                //   // tempSpeed += diff;
                //   // let text = Math.round(Number((APIList.length - this.progressCnt) * (tempSpeed / (i + 1))));
                //   // this.text = `${text} ${this.$t('unit.second')}`;
                // }

                this.$emit('onSaveClick', event, true, listData.includeList.filter(x => !listData.excludeList.includes(x)).map((apiItem) => {
                  return {
                    "startDatetime": apiItem,
                    "progressTime": "00:15:00",
                  }
                }), reset, () => {
                  this.modalClose();
                });
              }
            })
            .catch(e => {
              console.error(`[getAllScheduleByRangeForClinic] ${e}`);
            })
            .finally(() => {
              this.progress = false;
              this.progressLength = undefined;
              this.progressCnt = undefined;
              this.text = undefined;
            })
      }

      if (listData !== undefined) {
        if (check === true && listData.overlap) {
          this.$modal.show('yes-or-no-modal', {
            questionType: 'overlap',
            function: () => {
              setTimeout(() => {
                this.handleSave(event, false, listData)
              }, 1000)
            }
          })
        } else {
          if (listData.includeList.length !== 0) {
            this.$modal.show('yes-or-no-modal', {
              questionType: 'month_repeat',
              function: () => {
                registration()
              }
            })
          } else {
            this.$emit('onSaveClick', [], []);
          }
        }
      }
    },
    setTimeRange(no, from = true) {
      return this.timeRange.filter((value, index, array) => {
        try {
          if (from) {
            if (value.no !== 57) {
              if (value.no !== 0 && no !== 0) {
                return value.no < no
              } else {
                return true;
              }
            } else {
              return false;
            }
          } else {
            if (value.no !== 1) {
              if (value.no !== 0 && no !== 0) {
                return value.no > no
              } else {
                return true;
              }
            } else {
              return false;
            }
          }
        } catch (e) {
          return true;
        }
      })
    },
  },
  watch: {
    weekDays: {
      deep: true,
      handler(newData) {
        this.weekLabel = newData.map((item) => {
          return {
            ...item,
            label: (item.short === undefined ? item.label : item.short).substring(0, 3),
          }
        })
      }
    }
  },
}
</script>
<style lang="scss" src="./monthRepeat.scss"/>